import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import BankForm from '../../../components/forms/BankForm';
import { useBankApi } from '../../../hooks/useBankApi';
import { useNavigate } from 'react-router-dom';
import { BankDTO } from '../../../services/apiClient';

const BankCreate: React.FC = () => {
  const { create, isLoading } = useBankApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Banks', href: '/admin/banks' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: BankDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/banks');
    } catch (error) {
      console.error('Error creating Bank:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      title="Create Bank"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
        <BankForm
          initialValues={{} as BankDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/banks')}
          //isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default BankCreate;